import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }
    
    body {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
        "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
        sans-serif;
    }

    * {
        box-sizing: border-box;
    }
    *::selection {
        background-color: ${props =>
          props.theme.colors.highlightColors?.highlightColorBackground
            ? props.theme.colors.highlightColors?.highlightColorBackground
            : props?.theme?.colors?.brand?.medium};
        color: ${props =>
          props.theme.colors.highlightColors?.highlightColorText
            ? props.theme.colors.highlightColors?.highlightColorText
            : props?.theme?.colors?.brand?.lights[0]};
    }

    a {
        text-decoration: none;
    }

    button {
        padding: 0;
        border: 0;
        outline: none;
        cursor: pointer;
        background-color: transparent;
    }   
`

export default GlobalStyle
